module.exports = __webpack_public_path__ + "img/N660-1.63836558.png";